/* ======================================================================================================================
   SWB v2: the saved watch, applied on every page
   Theme #200092287359. Loaded (deferred, after swb-v2.js) by sections/swb-header-v2.liquid, so it runs on every
   template. Additive: it drives other sections only through what they already expose (their own <select>s and the
   store's switchModuleLandingPageSelect contract) and never edits their markup.

   Where the watch lives: swb-v2.js owns it. sessionStorage.swbV2Watch for this tab, the cart attributes
   switch-module-brand / -model / -url for everything server rendered and for the next visit, broadcast as the DOM
   event `swb-v2:watch`. window.swbV2 = { get, set(w, quiet), quiet(), event }.

   Five jobs:
     1. BRIDGE    a watch picked in the header on a page that has a switchModuleLandingPageSelect hook (sale page,
                  under-15 page, back-to-routine, lp-universal) is handed to that hook, so the page itself follows
                  instead of the picker sending the visitor off to a collection. This is exactly what the original
                  switch module did after its cart write. Quiet writes (restores) are never handed over: pages
                  with a hook already preselect from the cart on load.
     2. ADAPTERS  pages whose own brand/model <select>s carry collection URLs as model values. The saved watch is
                  set into them on load when the page has not already chosen one, and a pick made IN them is
                  written back as the saved watch, so a choice made anywhere counts everywhere.
     3. MODEL COLLECTIONS  landing directly on a model collection is never overridden. It only becomes the saved
                  watch when there is none yet (see adoptModelCollection), unless the visitor got there by picking it
                  in a page's own picker, which is a choice like any other.
     4. PICKERS   every other model selector in the store writes its pick back as the saved watch: the all hub finder,
                  the bundle builder, the brand strap pages, the Universal PDP, the materials/occasions browse, the
                  landing pages that announce switch-module:landing-selected, and any page whose picker leaves by
                  script for a model collection (see PICKERS below).
     5. SPOTLER   a real change of watch is sent to Spotler with the exact call of the original switch module.

   Matching is by collection URL path wherever the page gives one, so a translated title or a brand that shares words
   with another ("Galaxy Watch 6" inside "Galaxy Watch 6 Classic") cannot land on the wrong model. The locale prefix
   (/en, /fr) is ignored, because the same market can be browsed in a second language with prefixed links. The two
   landing pages that only announce names (u15, lp-universal) are matched by exact name and skipped when unsure.
   ====================================================================================================================== */
(function () {
  'use strict';

  if (window.swbV2WatchBooted) return;
  window.swbV2WatchBooted = true;

  var EVENT = 'swb-v2:watch';

  function api() {
    return window.swbV2 && typeof window.swbV2.get === 'function' ? window.swbV2 : null;
  }

  /* "/en/collections/Foo-Bar/?x=1#y" and "https://host/collections/foo-bar" -> "/collections/foo-bar" */
  function pathKey(u) {
    if (!u) return '';
    var p = String(u).replace(/^https?:\/\/[^/]+/i, '').split('#')[0].split('?')[0];
    p = p.replace(/\/+$/, '').toLowerCase();
    p = p.replace(/^\/[a-z]{2}(-[a-z]{2})?(?=\/collections\/)/, '');
    return p;
  }

  function saved() {
    var a = api();
    var w = a ? a.get() : null;
    return w && w.url && w.url !== '#' ? w : null;
  }

  function optText(sel) {
    var o = sel && sel.options[sel.selectedIndex];
    return o ? o.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  function fire(el) {
    el.dispatchEvent(new Event('change', { bubbles: true }));
  }

  /* --------------------------------------------------------------------------------------------------------------
     1. BRIDGE
     -------------------------------------------------------------------------------------------------------------- */
  var bridging = false;
  document.addEventListener(EVENT, function (ev) {
    var w = ev.detail;
    var a = api();
    if (!w || !w.url || bridging) return;
    if (a && typeof a.quiet === 'function' && a.quiet()) return;
    var hook = window.switchModuleLandingPageSelect;
    if (typeof hook !== 'function') return;
    var ok = false;
    bridging = true;
    try {
      ok = hook({ brand: w.brand || '', model: w.model || '', url: w.url, filter: '' }) === true;
    } catch (e) {
      ok = false;
    } finally {
      bridging = false;
    }
    /* The page took it: close the popover or sheet so the visitor sees their page change, which is what the
       original modal did on the same contract. Announcing a panel nobody owns closes every open one. */
    if (ok) document.dispatchEvent(new CustomEvent('swb-v2:panel', { detail: 'page' }));
  });

  /* --------------------------------------------------------------------------------------------------------------
     2. ADAPTERS
     preselect: false where the page already preselects itself from the cart (the sale page does, via cart.js).
     -------------------------------------------------------------------------------------------------------------- */
  var ADAPTERS = [
    { name: 'herfst', brand: '[data-hf-brand]', model: '[data-hf-model]', preselect: true },
    { name: 'sale', brand: 'select[data-brand-select]', model: 'select[data-model-select]', preselect: false }
  ];

  function findModelOption(modelSel, key) {
    for (var i = 0; i < modelSel.options.length; i++) {
      if (modelSel.options[i].value && pathKey(modelSel.options[i].value) === key) return i;
    }
    return -1;
  }

  /* Walk the page's brand options until its model list offers the saved URL. The brand whose name matches the saved
     brand is tried first, so the usual cost is one change event. If nothing fits, the brand select is put back
     exactly as it was. */
  function preselectPair(brandSel, modelSel, w) {
    var key = pathKey(w.url);
    if (!key) return false;
    var before = brandSel.selectedIndex;
    var want = String(w.brand || '').toLowerCase().trim();
    var order = [];
    for (var i = 0; i < brandSel.options.length; i++) {
      var o = brandSel.options[i];
      if (o.disabled && !o.value) continue;
      var txt = o.textContent.toLowerCase().trim();
      if (want && (txt === want || String(o.value).toLowerCase() === want)) order.unshift(i);
      else order.push(i);
    }
    for (var n = 0; n < order.length; n++) {
      brandSel.selectedIndex = order[n];
      fire(brandSel);
      var mi = findModelOption(modelSel, key);
      if (mi > -1) {
        modelSel.selectedIndex = mi;
        fire(modelSel);
        return true;
      }
    }
    brandSel.selectedIndex = before;
    fire(brandSel);
    return false;
  }

  function initAdapters() {
    ADAPTERS.forEach(function (ad) {
      var brandSels = document.querySelectorAll(ad.brand);
      [].forEach.call(brandSels, function (brandSel) {
        if (brandSel.hasAttribute('data-v2w-ready')) return;
        // the pair lives in the same section; never pair a brand select with another section's model select
        var scope = brandSel.closest('.shopify-section') || document;
        var modelSel = scope.querySelector(ad.model);
        if (!modelSel) return;
        brandSel.setAttribute('data-v2w-ready', '');

        /* Written back quietly: the page has applied this pick itself, so handing it to the bridge again would make
           the page apply it twice. isTrusted keeps our own preselect from echoing. */
        modelSel.addEventListener('change', function (ev) {
          if (!ev.isTrusted) return;
          var url = modelSel.value;
          var a = api();
          if (!a || !url || url.indexOf('/collections/') === -1) return;
          a.set({ brand: optText(brandSel), model: optText(modelSel), url: url }, 'echo');
        });

        /* A value already in the picker at this point came from the page's OWN memory of an earlier visit (herfst keeps
           sessionStorage 'hf-model'), never from a pick on this page load. Every pick made in it was written back as
           the saved watch, so the saved watch is at least as recent: when they disagree, the saved watch wins. */
        if (!ad.preselect) return;
        var w = saved();
        if (w && pathKey(modelSel.value) !== pathKey(w.url)) preselectPair(brandSel, modelSel, w);
      });
    });
  }

  /* --------------------------------------------------------------------------------------------------------------
     3. MODEL COLLECTIONS
     Arriving on /collections/<model> (an ad, a search result, a shared link) is the page the visitor asked for, so
     nothing here ever redirects or re-filters it to the saved watch.

     Does it change the saved watch? Only when there is none. With no choice on record, landing on a model's own
     collection is the best evidence we will get of which watch they own, and saving it lets the pill and every
     later page personalise. An existing choice is NOT replaced: it was made deliberately in a picker, while a
     collection visit is often someone browsing for a partner's watch or following a cross link, and silently
     swapping their watch would make every later page wrong. Picking in the header on that page still replaces it,
     as it does anywhere. Only an exact match against a MODEL entry of the brand menus counts, so a brand, material or
     sale collection is never mistaken for a watch.
     -------------------------------------------------------------------------------------------------------------- */
  function adoptModelCollection() {
    var from = pickedOnLastPage(); // read on every page, so a stale mark never outlives the page after it
    var here = pathKey(location.pathname);
    if (!/^\/collections\/[^/]+$/.test(here)) return;
    /* A filter or sort on this same collection that reloads it is not a pick; only arriving from another page is */
    if (from && pathKey(from) !== here) {
      var w = byUrl(here);
      if (w) {
        adopt(w);
        return;
      }
    }
    if (saved()) return;
    var a = api();
    var src = document.querySelector('script[id^="v2-brands-hdr-"]');
    if (!a || !src) return;
    var data = [];
    try {
      data = JSON.parse(src.textContent) || [];
    } catch (e) {
      return;
    }
    for (var b = 0; b < data.length; b++) {
      var models = data[b].m || [];
      for (var m = 0; m < models.length; m++) {
        if (models[m].u && models[m].u !== '#' && pathKey(models[m].u) === here) {
          a.set({ brand: data[b].b, model: models[m].t, url: models[m].u }, true);
          return;
        }
      }
    }
  }

  /* --------------------------------------------------------------------------------------------------------------
     3b. ACCESSORY MODEL COLLECTIONS (2026-10-21, asked: "accessories by brand, Fitbit > Charge 3: on the accessories
     page Charge was not preselected"). /collections/fitbit-charge-3-accessoires is the accessories page of a model,
     but its URL is not the model's strap collection, so section 3 never recognised it. Here the page title, minus the
     accessory word, is matched by exact name against the brand menus' models ("Fitbit Charge 3" -> Charge 3). Same
     rules as section 3: it becomes the watch when none is saved; it replaces a saved one only when the visitor picked
     this model in the header's accessories menu a moment ago (a deliberate choice, marked on the click).
     -------------------------------------------------------------------------------------------------------------- */
  var ACC_WORDS = /\b(accessoires|accessories|accessory|zubehor|zubehoer|accesorios|accessoire)\b/g;
  var ACC_MARK = 'swbV2AccPick';
  function adoptAccessoryModel() {
    var here = pathKey(location.pathname);
    if (!/^\/collections\/[^/]+$/.test(here)) return;
    if (!/(accessoires|accessories|zubehor|zubehoer|accesorios)/.test(here)) return;
    var h1 = document.querySelector('main h1, h1');
    var title = norm(h1 ? h1.textContent : '');
    if (!title) return;
    var name = title.replace(ACC_WORDS, ' ').replace(/\s+/g, ' ').trim();
    if (!name) return;
    var hits = {};
    index().forEach(function (r) {
      var rb = norm(r.brand);
      var rm = norm(r.model);
      if (rm === name || rb + ' ' + rm === name || (rm.indexOf(rb + ' ') === 0 && rm === name)) hits[r.key] = r;
    });
    var keys = Object.keys(hits);
    if (keys.length !== 1) return;
    var w = entry(hits[keys[0]]);
    var picked = false;
    try {
      var m = JSON.parse(sessionStorage.getItem(ACC_MARK) || 'null');
      sessionStorage.removeItem(ACC_MARK);
      picked = !!(m && Date.now() - m.t < 15000 && pathKey(m.href) === here);
    } catch (e) {
      /* ignore */
    }
    if (picked) {
      adopt(w);
      return;
    }
    if (saved()) return;
    var a = api();
    if (a) a.set({ brand: w.brand, model: w.model, url: w.url }, true);
  }
  document.addEventListener(
    'click',
    function (ev) {
      if (!ev.isTrusted || !ev.target || !ev.target.closest) return;
      var l = ev.target.closest('.v2-mega a[href], .v2-sheet a[href]');
      if (!l) return;
      var href = l.getAttribute('href') || '';
      if (!/(accessoires|accessories|zubehor|zubehoer|accesorios)/.test(href)) return;
      try {
        sessionStorage.setItem(ACC_MARK, JSON.stringify({ t: Date.now(), href: href }));
      } catch (e) {
        /* ignore */
      }
    },
    true
  );

  /* --------------------------------------------------------------------------------------------------------------
     4. PICKERS
     Every original page picker keeps working exactly as it did; this only listens. A pick is written back through
     adopt(), which writes as an 'echo': stored, sent to the cart and announced like any new choice, but never
     handed back to the page's own hook, because the page has already applied it.

     What counts as a pick is deliberately narrow. The pick has to follow the visitor's own input (a trusted click,
     key or change within the last 1.5 s), and it has to resolve to a MODEL entry of the header's brand menus, the
     same list the pill is drawn from, so brand, material and sale collections never become a watch.

       links    a click on an element that carries the model's collection URL: the all hub finder results
                (swb-all-hub), the bundle builder's model rows (swb-bundle.js) and the brand strap pages' model
                buttons and search suggestions (universal-brand-template).
       selects  the Universal PDP's model select. Its sticky bar re-dispatches a pick onto that same select, so
                both are covered by one capture listener.
       events   switch-module:landing-selected, which u15 and lp-universal announce for a pick made in their own
                picker. Picks the bridge handed to them arrive while `bridging` is set and are ignored.
       ?model=  the materials and occasions browse keeps the chosen model in its URL; a new value that follows a
                click is a pick. Arriving with ?model= in the link is not, just like a collection visit.
       leaving  pages whose picker computes the destination in script and leaves with location.href (materials,
                occasions, reviews, loyalty and expert pickers): the last trusted click before leaving was not on
                a link, and the next page is a model collection reached from this page within 15 s. A click on any
                link clears the mark, so ordinary browsing into a collection never counts.
     -------------------------------------------------------------------------------------------------------------- */
  var lastInput = 0;
  ['pointerdown', 'keydown', 'change'].forEach(function (type) {
    document.addEventListener(
      type,
      function (ev) {
        if (ev.isTrusted) lastInput = Date.now();
      },
      true
    );
  });
  function byHand() {
    return Date.now() - lastInput < 1500;
  }

  var INDEX = null;
  function index() {
    if (INDEX) return INDEX;
    INDEX = [];
    var src = document.querySelector('script[id^="v2-brands-hdr-"]');
    if (!src) return INDEX;
    var data = [];
    try {
      data = JSON.parse(src.textContent) || [];
    } catch (e) {
      return INDEX;
    }
    data.forEach(function (b) {
      (b.m || []).forEach(function (m) {
        if (m.u && m.u !== '#') INDEX.push({ brand: b.b, model: m.t, url: m.u, key: pathKey(m.u) });
      });
    });
    return INDEX;
  }

  function entry(r) {
    return { brand: r.brand, model: r.model, url: r.url };
  }

  function byUrl(u) {
    var key = pathKey(u);
    if (!/^\/collections\/[^/]+$/.test(key)) return null;
    var ix = index();
    for (var i = 0; i < ix.length; i++) if (ix[i].key === key) return entry(ix[i]);
    return null;
  }

  function norm(s) {
    return String(s || '')
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  /* Exact names only ("Series 10" under "Apple Watch" is "Apple Watch Series 10"). Anything that does not land on
     exactly one collection is left alone: a missed pick costs one re-pick, a wrong one mislabels every page. */
  function byName(brand, model) {
    var nb = norm(brand);
    var nm = norm(model);
    if (!nm || nm === nb) return null;
    var hits = {};
    index().forEach(function (r) {
      var rb = norm(r.brand);
      var rm = norm(r.model);
      if (nb && rb !== nb && rb.indexOf(nb + ' ') !== 0 && nb.indexOf(rb + ' ') !== 0) return;
      if (rm === nm || rm === rb + ' ' + nm || rm === nb + ' ' + nm) hits[r.key] = r;
    });
    var keys = Object.keys(hits);
    return keys.length === 1 ? entry(hits[keys[0]]) : null;
  }

  function adopt(w) {
    var a = api();
    if (!a || !w || !w.url) return false;
    var cur = saved();
    if (cur && pathKey(cur.url) === pathKey(w.url)) return false;
    a.set({ brand: w.brand, model: w.model, url: w.url }, 'echo');
    return true;
  }

  var LINKS = [
    '[data-ah-find-res] a[href]',
    '[data-swb-model-list] [data-swb-mrow][data-url]',
    'a.ulp-btn[href]',
    'a.ulp-sug[href]'
  ].join(',');

  var MARK = 'swbV2PickNav';
  var mbModel = null;

  function browseModel() {
    return new URLSearchParams(location.search).get('model') || '';
  }
  function onBrowse() {
    return !!document.querySelector('[id^="mb-sort-"]');
  }
  function checkBrowse() {
    if (mbModel === null) return;
    var h = browseModel();
    if (h === mbModel) return;
    mbModel = h;
    if (h && byHand()) adopt(byUrl('/collections/' + h));
  }

  /* Capture phase: the bundle builder re-renders its list on the same click and the hub result is a link that is
     about to unload the page, so the pick is read before either happens. Modified clicks (a new tab) count too:
     choosing a model is the same decision wherever it opens. */
  document.addEventListener(
    'click',
    function (ev) {
      if (!ev.isTrusted || !ev.target || !ev.target.closest) return;
      var el = ev.target.closest(LINKS);
      if (el) adopt(byUrl(el.getAttribute('data-url') || el.getAttribute('href')));
      try {
        if (ev.target.closest('a[href]')) sessionStorage.removeItem(MARK);
        else sessionStorage.setItem(MARK, JSON.stringify({ t: Date.now(), from: location.pathname }));
      } catch (e) {
        /* ignore */
      }
      if (mbModel !== null) setTimeout(checkBrowse, 0);
    },
    true
  );
  document.addEventListener(
    'keydown',
    function (ev) {
      if (!ev.isTrusted || ev.key !== 'Enter') return;
      try {
        sessionStorage.setItem(MARK, JSON.stringify({ t: Date.now(), from: location.pathname }));
      } catch (e) {
        /* ignore */
      }
      if (mbModel !== null) setTimeout(checkBrowse, 0);
    },
    true
  );

  document.addEventListener(
    'change',
    function (ev) {
      var t = ev.target;
      if (!t || !t.matches || !t.matches('#upp-main select[data-model]') || !byHand()) return;
      var o = t.options[t.selectedIndex];
      if (!o || !o.value) return;
      var w = byUrl(o.getAttribute('data-url') || o.value);
      if (!w && o.getAttribute('data-handle')) w = byUrl('/collections/' + o.getAttribute('data-handle'));
      adopt(w);
    },
    true
  );

  document.addEventListener('switch-module:landing-selected', function (ev) {
    if (bridging || !byHand()) return;
    var d = ev.detail || {};
    var w = (d.url && byUrl(d.url)) || byName(d.brand, d.model);
    if (!w) {
      // lp-universal has just pointed its "view model" links at the picked model's collection
      var cta = document.querySelector('#lp-page .lp-dyn-cta[href]');
      if (cta && d.model && norm(d.model) !== norm(d.brand)) w = byUrl(cta.getAttribute('href'));
    }
    adopt(w);
  });

  /* The path of the page this one was left from by script right after a click that was not on a link, or ''. */
  function pickedOnLastPage() {
    var raw = null;
    try {
      raw = sessionStorage.getItem(MARK);
      sessionStorage.removeItem(MARK);
    } catch (e) {
      return '';
    }
    if (!raw) return '';
    var mark = null;
    try {
      mark = JSON.parse(raw);
    } catch (e) {
      return '';
    }
    if (!mark || !mark.t || Date.now() - mark.t > 15000) return '';
    var nav = window.performance && performance.getEntriesByType ? performance.getEntriesByType('navigation')[0] : null;
    if (nav && nav.type !== 'navigate') return ''; // a reload or Back is not a pick
    var from = '';
    try {
      var ref = new URL(document.referrer);
      if (ref.host !== location.host) return '';
      from = ref.pathname;
    } catch (e) {
      return '';
    }
    return from === mark.from ? from : '';
  }

  /* --------------------------------------------------------------------------------------------------------------
     5. SPOTLER
     The original switch module's Spotler call lives in GTM (container GTM-MTNJX4DW, tag 195), not in the theme:
       window._sqzl.push({ event: 'SelectWatch', custom_smartwatch_selected: <brand> })
     fired on a click on a .brand-button, with the brand's name as the value. This sends that exact call.

     Once per real change: only a write made just now (w.t fresh) that names a different watch from the one before
     it. Restores on page load keep their old t, and re-picking the watch already saved changes nothing.
     Consent: GTM only creates window._sqzl after marketing consent, so no _sqzl means nothing is sent; nothing here
     ever creates it or loads Spotler.
     -------------------------------------------------------------------------------------------------------------- */
  var lastKey = (function () {
    var w = saved();
    return w ? pathKey(w.url) : '';
  })();

  /* A pick adopted while the page boots (arriving from a picker that left by script) happens before GTM has run, so
     _sqzl may not exist yet. Wait up to 10 s for GTM to create it; if it never does, consent was not given and the
     call is dropped. Only the latest pick waits: a newer one replaces it. */
  var sqzlWait = 0;
  function selectWatch(w) {
    var brand = String(w.brand || '').replace(/\s+/g, ' ').trim();
    if (!brand) return;
    var tries = 0;
    clearInterval(sqzlWait);
    function send() {
      var q = window._sqzl;
      if (!q || typeof q.push !== 'function') return false;
      var cb = window.Cookiebot;
      if (cb && cb.consent && cb.consent.marketing === false) return true;
      try {
        /* brand as before (GTM tag 195's field), plus the exact model and its collection, so Spotler's profile
           can hand the watch back on a later visit or another device (see SPOTLER FAVOURITE WATCH below) */
        q.push({
          event: 'SelectWatch',
          custom_smartwatch_selected: brand,
          custom_smartwatch_model: String(w.model || '').trim(),
          custom_smartwatch_url: pathKey(w.url)
        });
      } catch (e) {
        /* ignore */
      }
      return true;
    }
    if (send()) return;
    sqzlWait = setInterval(function () {
      if (send() || ++tries >= 40) clearInterval(sqzlWait);
    }, 250);
  }

  var fromSpotler = false;
  document.addEventListener(EVENT, function (ev) {
    var w = ev.detail;
    var key = w && w.url ? pathKey(w.url) : '';
    var changed = key !== lastKey;
    lastKey = key;
    // a watch Spotler handed us is not echoed back to Spotler as a new pick
    if (key && changed && w.t && Date.now() - w.t < 5000 && !fromSpotler) selectWatch(w);
  });

  /* --------------------------------------------------------------------------------------------------------------
     SPOTLER FAVOURITE WATCH
     Spotler keeps the visitor's watch in their profile (the SelectWatch fields above) and can recognise the same
     person on a new device or after the session ended. A Spotler personalisation on every page hands it back as
       window.swbSpotlerWatch = { brand, model, url }        or   the event 'swb-v2:spotler-watch' with that detail
     and the switch module takes it, so the right straps show everywhere, but ONLY when this visitor has not chosen
     a watch here: a pick on the site always wins over a remembered one. The value is resolved against this store's
     own model collections (by collection url, else exact brand + model name); anything that does not land on
     exactly one model is ignored rather than mislabelling every page.
     -------------------------------------------------------------------------------------------------------------- */
  function takeSpotler(d) {
    if (!d || saved()) return false;
    var w = (d.url && byUrl(d.url)) || byName(d.brand, d.model);
    if (!w) return false;
    fromSpotler = true;
    try { adopt(w); } finally { fromSpotler = false; }
    return true;
  }
  window.swbV2SpotlerWatch = takeSpotler;
  document.addEventListener('swb-v2:spotler-watch', function (ev) { takeSpotler(ev.detail); });
  (function waitSpotler() {
    // the personalisation loads after the page; look for its global for a few seconds
    var n = 0;
    var t = setInterval(function () {
      if (window.swbSpotlerWatch && takeSpotler(window.swbSpotlerWatch)) clearInterval(t);
      else if (++n > 40 || saved()) clearInterval(t);
    }, 250);
  })();

  function boot() {
    if (onBrowse()) mbModel = browseModel();
    initAdapters();
    adoptModelCollection();
    adoptAccessoryModel();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // Back restores a page from the bfcache without re-running scripts; the saved watch may have changed meanwhile
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    var w = saved();
    if (!w) return;
    ADAPTERS.forEach(function (ad) {
      if (!ad.preselect) return;
      [].forEach.call(document.querySelectorAll(ad.brand), function (brandSel) {
        var scope = brandSel.closest('.shopify-section') || document;
        var modelSel = scope.querySelector(ad.model);
        if (modelSel && pathKey(modelSel.value) !== pathKey(w.url)) preselectPair(brandSel, modelSel, w);
      });
    });
  });
})();
